import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var HeartSquareIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 25 24",
                    children: [
                        _jsx("path", {
                            d: "M21.265 23.35H3.745c-.69 0-1.34-.27-1.83-.76-.48-.48-.76-1.15-.76-1.83V3.24c0-.69.27-1.34.76-1.83s1.14-.76 1.83-.76h17.51c.69 0 1.34.27 1.83.76s.76 1.14.76 1.83v17.51c0 .68-.28 1.35-.76 1.83-.49.49-1.14.76-1.83.76l.01.01zM3.745 2.65a.59.59 0 00-.42.17.59.59 0 00-.17.42v17.51c0 .16.06.31.17.42.11.11.26.17.42.17h17.51c.16 0 .31-.06.42-.17a.59.59 0 00.17-.42V3.24a.59.59 0 00-.17-.42.59.59 0 00-.42-.17H3.745z"
                        }),
                        _jsx("path", {
                            d: "M12.505 18.57c-.24 0-.49-.09-.68-.27l-4.78-4.43c-1.07-1.04-1.46-2.5-1.06-3.92.4-1.43 1.54-2.55 2.89-2.86.75-.17 2.12-.22 3.62 1.04 1.5-1.26 2.87-1.21 3.62-1.04 1.36.31 2.49 1.43 2.89 2.86.4 1.42 0 2.87-1.04 3.9l-4.79 4.44c-.19.18-.44.27-.68.27l.01.01zm-2.83-9.55c-.12 0-.23.01-.35.04-.65.15-1.21.72-1.41 1.45-.12.42-.21 1.22.51 1.93l4.08 3.78 4.1-3.8c.7-.68.61-1.49.49-1.91-.21-.73-.76-1.3-1.41-1.45-.76-.17-1.62.24-2.43 1.15-.38.43-1.12.43-1.5 0-.69-.78-1.41-1.19-2.08-1.19z"
                        })
                    ]
                })
            })
        ]
    });
};
HeartSquareIcon.isCarinaIcon = true;
export default HeartSquareIcon;
